import ChevronDownIcon from '@persona-id/design-tokens/icons/ChevronDownIcon';
import { SyntheticEvent } from 'react';
import { Controller } from 'react-hook-form';
import { FormError } from 'shared/components/FormControl';
import styled from 'styled-components';

import { ImporterType } from 'dashboard/models/importer';
import ImporterTypeSelector from 'dashboard/views/DashboardImporterStepperView/ImporterTypeSelector';
import StepperCard from 'dashboard/views/DashboardImporterStepperView/StepperCard';
import StepperFormControlLabel from 'dashboard/views/DashboardImporterStepperView/StepperFormControlLabel';
import Button from 'design-system/components/Button';
import Input from 'design-system/components/Input';
import Spacer from 'design-system/components/Spacer';

type SelectDataSourceStepProps = {
  canAdvance: boolean;
  control: any;
  errors: any;
  handleNextButtonClick: () => void;
  handleSelectImporterType: (type: ImporterType) => void;
  importerTypes: { value: ImporterType; label: string }[];
  isActive: boolean;
  handleCardClick: () => void;
  onImporterNameChange: (name: string) => void;
  selectedImporterType: ImporterType;
};
const PartialFormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const SelectDataSourceStep = ({
  canAdvance,
  control,
  errors,
  handleNextButtonClick,
  handleSelectImporterType,
  importerTypes,
  isActive,
  handleCardClick,
  selectedImporterType,
}: SelectDataSourceStepProps) => {
  return (
    <StepperCard
      id='importer-stepper-panel__setup-importer'
      title='1. Set up importer'
      actions={
        isActive ? (
          <Button
            disabled={!canAdvance}
            variant='basic'
            id='importer-stepper-panel__setup-importer-next'
            onClick={(e: SyntheticEvent<HTMLButtonElement>) => {
              e.preventDefault();
              e.stopPropagation();
              handleNextButtonClick();
            }}
          >
            Next
          </Button>
        ) : (
          <ChevronDownIcon />
        )
      }
      onClick={() => handleCardClick()}
      active={isActive}
    >
      <PartialFormContainer>
        <StepperFormControlLabel>Name</StepperFormControlLabel>
        <Controller
          control={control}
          name='name'
          rules={{
            required: 'Name is required',
            minLength: {
              value: 3,
              message: 'Name must be at least 3 characters in length',
            },
            validate: (val) => {
              if (val == null) {
                return 'Name is required';
              }
              const sanitizedValue = val.trim();
              if (sanitizedValue === '') {
                return 'Name is required';
              }
            },
          }}
          render={({ field: { onChange, value } }) => {
            return (
              <Input
                id='importer-stepper-panel__importer-name'
                onChange={onChange}
                placeholder='Ex. International Accounts'
                type='text'
                value={value}
              />
            );
          }}
        />
        {errors.name && <FormError>{errors.name.message}</FormError>}
        <Spacer height={3.5} />
        <ImporterTypeSelector
          importerTypes={importerTypes}
          onSelectImporterType={handleSelectImporterType}
          selectedImporterType={selectedImporterType}
        />
        <Spacer height={2} />
      </PartialFormContainer>
    </StepperCard>
  );
};

export default SelectDataSourceStep;
